import translateErrorOld from 'utils/backend/translateErrorOld.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const createCallException = (options) => ({
  name: 'CallException',
  message: translateErrorOld(fromAnyToString(options?.message), 'api:CallException'),
  code: options?.code,
  body: options?.body,
  ctype: options?.ctype,
});

export default createCallException;
